import { render, staticRenderFns } from "./1-PlayerDetails.vue?vue&type=template&id=40cf0d32&scoped=true"
import script from "./1-PlayerDetails.vue?vue&type=script&lang=js"
export * from "./1-PlayerDetails.vue?vue&type=script&lang=js"
import style0 from "./1-PlayerDetails.vue?vue&type=style&index=0&id=40cf0d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf0d32",
  null
  
)

export default component.exports